import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Home, ArrowLeft, Search } from 'lucide-react';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-slate-900 to-orange-900 flex items-center justify-center px-6">
      <div className="max-w-2xl mx-auto text-center">
        {/* 404 Text */}
        <div className="mb-8">
          <h1 className="text-9xl md:text-[200px] font-bold bg-gradient-to-r from-purple-400 via-pink-400 to-orange-400 bg-clip-text text-transparent leading-none">
            404
          </h1>
        </div>

        {/* Message */}
        <div className="mb-8">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Oops! Page Not Found
          </h2>
          <p className="text-gray-300 text-lg mb-2">
            The page you&apos;re looking for doesn&apos;t exist or has been moved.
          </p>
          <p className="text-gray-400 text-base">
            Let&apos;s get you back on track to learn professional video editing!
          </p>
        </div>

        {/* Animated Search Icon */}
        <div className="mb-10 flex justify-center">
          <div className="relative">
            <div className="absolute inset-0 bg-purple-500/20 rounded-full blur-2xl animate-pulse"></div>
            <div className="relative bg-white/10 backdrop-blur-md border border-white/20 rounded-full p-6">
              <Search className="h-16 w-16 text-purple-400" />
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            onClick={() => navigate('/')}
            className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white px-8 py-6 text-lg rounded-full shadow-2xl transform hover:scale-105 transition-all duration-300 border-0"
          >
            <Home className="mr-2 h-5 w-5" />
            Go to Homepage
          </Button>
          
          <Button
            onClick={() => navigate(-1)}
            variant="outline"
            className="bg-white/10 backdrop-blur-md border-2 border-white/30 text-white px-8 py-6 text-lg rounded-full hover:bg-white/20 transform hover:scale-105 transition-all duration-300"
          >
            <ArrowLeft className="mr-2 h-5 w-5" />
            Go Back
          </Button>
        </div>

        {/* Quick Links */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <p className="text-gray-400 text-sm mb-4">Or explore these sections:</p>
          <div className="flex flex-wrap gap-3 justify-center">
            {[
              { label: 'Courses', path: '/#courses' },
              { label: 'About Us', path: '/#about' },
              { label: 'Seminar', path: '/#seminar' },
              { label: 'Contact', path: '/#contact' }
            ].map((link, idx) => (
              <button
                key={idx}
                onClick={() => {
                  navigate('/');
                  setTimeout(() => {
                    const element = document.getElementById(link.path.replace('/#', ''));
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }, 100);
                }}
                className="px-4 py-2 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-purple-400 text-white text-sm rounded-full transition-all duration-300"
              >
                {link.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
